import React from 'react';
import Svgs from '../../resources/svgs';

const AccordianHeader = (props) => <div
    onClick={() => {
      props.handleClick(props.sectionKey);
    }}
    className={'accordian-section-header '}
    key={props.sectionKey}
    style={{color: props.textColor, padding: '10px'}}
    data-event="track-component"
        data-component-name={`Accordian Header ${props.idx}`}
        data-component-link={`Open section ${props.title}`}
        data-component-link-placement="1"
        data-component-link-type="title"
  >
    <div className="accordian-section-header-content">
      <div className="accordian-section-header-content-text">
        {props.children}
      </div>

      <div className="accordian-section-header-content-carrot">
        {Svgs.downarrow}
      </div>
    </div>
  </div>
;

export default AccordianHeader;
